import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
var render = function render() {
  var _vm$photo$comment, _vm$handlingComment$f, _vm$photo$comment2, _vm$photo$contents;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    attrs: {
      width: "800",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [!_vm.isAnyActionInProgress ? _c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle mt-1",
    on: {
      click: _vm.close
    }
  })], 1) : _vm._e(), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Tasting photo")])]), _c("div", {
    staticClass: "content-centered large text-left"
  }, [_vm.photo ? [_c("div", {
    staticClass: "text-smaller"
  }, [_c("div", [_c("span", {
    staticClass: "text-smaller"
  }, [_vm._v("Final customer")]), _vm._v(" : " + _vm._s(_vm.photo.targetedUser.fullName) + " ")]), _vm.photo.creationUser.id !== _vm.photo.targetedUser.id ? _c("div", [_c("span", {
    staticClass: "text-smaller"
  }, [_vm._v("Uploaded by " + _vm._s(_vm.photo.creationUser.fullName))])]) : _vm._e(), _c("div", {
    staticClass: "text-smaller"
  }, [_vm._v(" Uploaded on " + _vm._s(_vm._f("formatDate_string")(_vm.photo.creationDate)) + " ")]), _c("div", [_c("span", {
    staticClass: "text-smaller"
  }, [_vm._v("Status")]), _vm._v(" : "), _vm.isAdminManaging ? _c("span", [_vm._v(" " + _vm._s(Object.values(_vm.TASTING_PHOTOS.TAKEN.STATUS).find(function (x) {
    return x.id === _vm.photo.status;
  }).name) + " ")]) : _c("span", [_vm._v(" " + _vm._s(Object.values(_vm.TASTING_PHOTOS.TAKEN.STATUS).find(function (x) {
    return x.id === _vm.photo.status;
  }).nameForUser) + " ")])]), _vm.isCancelled ? _c("div", {
    staticClass: "text-italic"
  }, [_c("div", [_vm._v(" Cancelled by " + _vm._s(_vm.photo.cancellationUser.fullName) + " on " + _vm._s(_vm._f("formatDate_string")(_vm.photo.cancellationDate)) + " ")])]) : _vm.isTransferred ? _c("div", {
    staticClass: "text-italic text-smaller"
  }, [_vm._v(" " + _vm._s(_vm.isAdminManaging ? "Declared as transferred" : "Validated") + " by " + _vm._s(_vm.photo.transferUser.fullName) + " on " + _vm._s(_vm._f("formatDate_string")(_vm.photo.transferDate)) + " ")]) : _vm._e()]), !_vm.isCancelled ? _c("div", {
    staticClass: "text-center mt-default"
  }, [_c("img", {
    staticStyle: {
      "max-width": "100%",
      "max-height": "80vh"
    },
    attrs: {
      src: _vm.photo.absoluteUrlImage,
      alt: ""
    }
  }), _c("div", {
    staticClass: "flex justify-end"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small highlight",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.downloadPhoto();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-download mr-1"
  }), _vm._v(" Download photo ")], 1)], 1)]) : _vm._e(), _vm.isEditable ? [((_vm$photo$comment = _vm.photo.comment) === null || _vm$photo$comment === void 0 ? void 0 : _vm$photo$comment.length) > 0 || _vm.handlingComment.isConfiguringNew ? _c("div", [_c(VTextarea, {
    attrs: {
      label: "Comment",
      rows: "3",
      "hide-details": "auto"
    },
    model: {
      value: _vm.handlingComment.form.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.handlingComment.form, "comment", $$v);
      },
      expression: "handlingComment.form.comment"
    }
  }), _c("div", {
    staticClass: "mt-3 flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      rounded: ""
    },
    on: {
      click: _vm.removeComment
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-ban mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Remove comment ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress || !((_vm$handlingComment$f = _vm.handlingComment.form.comment) !== null && _vm$handlingComment$f !== void 0 && _vm$handlingComment$f.length) > 0 || _vm.handlingComment.form.comment === _vm.photo.comment,
      loading: _vm.handlingComment.updating.isPending
    },
    on: {
      click: _vm.saveComment
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save comment ")], 1)], 1)], 1) : !_vm.handlingComment.isConfiguringNew ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        _vm.handlingComment.isConfiguringNew = true;
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-comment mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add a comment ")], 1) : _vm._e()] : ((_vm$photo$comment2 = _vm.photo.comment) === null || _vm$photo$comment2 === void 0 ? void 0 : _vm$photo$comment2.length) > 0 ? [_c("div", {
    staticClass: "text-italic text-quote",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.photo.comment))
    }
  })] : _vm._e(), _c("div", {
    staticClass: "mt-default"
  }, [_c("div", [_vm._v("Bottle" + _vm._s(((_vm$photo$contents = _vm.photo.contents) === null || _vm$photo$contents === void 0 ? void 0 : _vm$photo$contents.length) > 1 ? "s" : "") + " seen on the photo")]), _c("div", {
    staticClass: "photo-contents-container"
  }, _vm._l(_vm.photo.contents, function (content) {
    return _c("div", {
      key: "photo-content-" + content.id,
      staticClass: "pb-2 mt-2 text-smaller flex items-start gap-2"
    }, [_vm.canCancelContent ? _c("div", [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.confirmCancelContent(content);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-times mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Cancel ")], 1)], 1) : _vm._e(), _c("div", [_vm._v(" " + _vm._s(content.nbBottles + "b. of " + content.tastingPhotoRequired.wine.displayName + ", from " + content.tastingPhotoRequired.fromReference.shorterReference()) + " ")])]);
  }), 0)]), _vm.isEditable ? _c("div", {
    staticClass: "mt-small"
  }, [!_vm.addingContent.isConfiguring ? _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      rounded: ""
    },
    on: {
      click: _vm.startAddContent
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add content ")], 1)], 1) : _vm._e(), _vm.addingContent.isConfiguring ? _c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.addingContent.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.addingContent.form, "valid", $$v);
      },
      expression: "addingContent.form.valid"
    }
  }, [_c("div", [_c(VAutocomplete, {
    attrs: {
      disabled: _vm.addingContent.availablePhotosRequired.isPending || _vm.isAnyActionInProgress,
      items: _vm.addingContent.availablePhotosRequired.items,
      "item-value": "id",
      "item-text": "name",
      label: !_vm.addingContent.availablePhotosRequired.isPending ? "Wine" : "Loading...",
      "hide-details": "auto",
      rules: [_vm.formRules.mustSelectValue]
    },
    model: {
      value: _vm.addingContent.form.tastingPhotoRequiredId,
      callback: function callback($$v) {
        _vm.$set(_vm.addingContent.form, "tastingPhotoRequiredId", $$v);
      },
      expression: "addingContent.form.tastingPhotoRequiredId"
    }
  }), _c(VTextField, {
    attrs: {
      disabled: !_vm.addingContent.form.tastingPhotoRequiredId > 0 || _vm.isAnyActionInProgress,
      label: "Nb bottles",
      "hide-details": "auto",
      type: "number",
      min: 1,
      rules: [_vm.formRules.mustBeGreaterThan0]
    },
    on: {
      keypress: _vm.filterIntegerKey
    },
    model: {
      value: _vm.addingContent.form.nbBottles,
      callback: function callback($$v) {
        _vm.$set(_vm.addingContent.form, "nbBottles", $$v);
      },
      expression: "addingContent.form.nbBottles"
    }
  }), _c("div", {
    staticClass: "mt-3 flex"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      disabled: _vm.isAnyActionInProgress,
      rounded: ""
    },
    on: {
      click: _vm.cancelAddingForm
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      disabled: _vm.isAnyActionInProgress || !_vm.addingContent.form.valid,
      loading: _vm.addingContent.isPending
    },
    on: {
      click: _vm.saveAddingContent
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add content ")], 1)], 1)], 1)]) : _vm._e()], 1) : _vm._e()] : _vm._e(), _vm.photo && _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("div", {
    staticClass: "mt-default"
  }, [_c(VAlert, {
    staticClass: "bypass-message --small",
    attrs: {
      dense: "",
      outlined: "",
      type: "warning",
      color: "orange",
      text: ""
    }
  }, [_vm._v(" Please keep the concerned people updated of any changes ")])], 1) : _vm._e(), _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [_vm.isCancellable ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress || _vm.addingContent.isConfiguring
    },
    on: {
      click: function click($event) {
        return _vm.confirmCancelPhoto();
      }
    }
  }, [_vm._v(" Cancel photo ")]) : _vm._e(), _vm.isAdminManaging && _vm.isTransferable ? _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: _vm.isAnyActionInProgress || _vm.addingContent.isConfiguring
    },
    on: {
      click: function click($event) {
        return _vm.confirmTransferPhoto();
      }
    }
  }, [_vm._v(" It's transferred ")]) : _vm._e()], 1)], 2)], 1)], 1), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };